import * as types from '../constants/actionTypes';

export function loadCustomers({status, data} = {}) {
    return {
        type: types.LOAD_CUSTOMERS
        , status
        , data
    };
}
export function setLoadingFlagForCustomerState() {
    return { type: types.SET_LOADING_FLAG_FOR_CUSTOMER_STATE };
}
export function syncCustomers({status, data} = {}) {
    return {
        type: types.SYNC_CUSTOMERS
        , status
        , data
    };
}



/** WEBPACK FOOTER **
 ** ./src/app/constants/customerActions.js
 **/